import { render, staticRenderFns } from "./letterSending.vue?vue&type=template&id=ff231d8a&scoped=true&"
import script from "./letterSending.vue?vue&type=script&lang=js&"
export * from "./letterSending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff231d8a",
  null
  
)

export default component.exports